import React, { useEffect, useState } from 'react';

const ResponsiveDescriptionCell = ({ description }) => {
    const [maxLength, setMaxLength] = useState(340); // default untuk desktop

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width >= 1200) {
                setMaxLength(340); // xl
            } else if (width >= 992) {
                setMaxLength(40); // lg
            } else if (width >= 820) {
                setMaxLength(75); // md
            } else if (width >= 768) {
                setMaxLength(35); // md
            } else {
                setMaxLength(35); // sm or xs
            }
        };

        handleResize(); // initial
        window.addEventListener('resize', handleResize); // listen resize

        return () => window.removeEventListener('resize', handleResize); // cleanup
    }, []);

    const visibleText =
        description?.length > maxLength
            ? `${description.slice(0, maxLength)}...`
            : description;

    return (
        <td
            style={{
                maxWidth: '300px',
                whiteSpace: 'normal',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
            }}
            title={description}
        >
            {visibleText}
        </td>
    );
};

export default ResponsiveDescriptionCell;
